import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';


export function RouterPrompt(props) {
  const { when, onOK, onCancel, title, okText, cancelText } = props;
  const context = React.useContext(DefaultContainerContext);

  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');
  const currentPathref = React.useRef('');

  useEffect(() => {
    if (when) {
      history.block((prompt) => {
        setCurrentPath(prompt.pathname);
        currentPathref.current = prompt.pathname;
        setShowPrompt(true);
        context.handleShowSystemDialog(true, {
          systemDialogType: 'warning',
          systemDialogTitle: 'Hmmm...',
          systemDialogContent: title,
          systemDialogCallback: () => handleOK(currentPath),
          systemDialogCancelCallback: () => handleCancel()
        });
        return 'true';
      });
    } else {
      history.block(() => {});
    }

    return () => {
      history.block(() => {});
    };
  }, [history, when]);

  const handleOK = useCallback(async () => {
    if (onOK) {
      const canRoute = await Promise.resolve(onOK());

      if (canRoute) {
        history.block(() => {});
        history.push(currentPath || currentPathref.current);
      }
    }
  }, [currentPath, history, onOK]);

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel());

      if (canRoute) {
        history.block(() => {});
        history.push(currentPath || currentPathref.current);
      }
    }
    setShowPrompt(false);
  }, [currentPath, history, onCancel]);


return null;
}
